export const callIfFunction = (func, ...args) => {
    if (typeof func === "function") {
        func(...args);
    }
};
